import React, { useEffect, useRef, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'

export default function AnimacionScroll() {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  // Animación con entrada y salida
  const estilos = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0px)' : 'translateY(40px)',
    config: { tension: 120, friction: 20 }
  })

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Si el elemento entra en pantalla → aparece
        if (entry.isIntersecting) {
          setVisible(true)
        } else {
          // Si sale de pantalla → desaparece
          setVisible(false)
        }
      },
      { threshold: 0.5 } // Se activa cuando el 20% del elemento es visible
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

 return (
  <div style={{ textAlign: 'left', marginTop: '0px' }}>
    <animated.h2 ref={ref} style={estilos}>
      <span
        style={{
          fontSize: '30px',
          fontWeight: 'bold',
          color: '#ffffff',
         fontFamily: "Space Grotesk, sans-serif"
        }}>DESAMUEBLADO VIRTUAL
      </span>
    </animated.h2>
  </div>
)}